<template>
  <div>
    <div id="top_border" :style="`background-color: ${headerBGColor} !important;`">
      <v-row style="align-items: center;">
        <v-col v-if="$route.name != 'Payment'" md="2" sm="2" cols="8" class="logo-resp" style="min-width: 203px">
          <a :href="sitesAppRoot">
            <img :src="logoUrl" alt="LiveLaps" height="50" border="0" @error="onLogoError" />
          </a>
        </v-col>
        <v-col v-if="$route.name == 'Payment'" md="2" sm="2" cols="8">
          <img :src="logoUrl" alt="LiveLaps" height="50" border="0" @error="onLogoError" />
        </v-col>
        <v-col v-if="$route.name == 'RegisterEvent' || $route.name == 'UnPaidRegistration' || $route.name == 'Payment'" 
               md="9" sm="9" cols="10" style="color:#fff;" class="header-resp">
          <TopMenu @changeDMenu="changeDMenu" @loadOptionsRegistration="loadOptionsRegistration"/>
        </v-col>
        <v-col v-if="$route.name == 'RegisterEvent' || $route.name == 'UnPaidRegistration' || $route.name == 'Payment'" 
               md="1" sm="1" cols="2" style="color:#fff;" class="lang-resp">
          <LanguageSwitcher />
        </v-col>
        <v-col v-if="$route.name != 'RegisterEvent' && $route.name != 'UnPaidRegistration' && $route.name != 'Payment'" 
               md="9" sm="9" cols="2" style="color:#fff;">
        </v-col>
        <v-col v-if="$route.name != 'RegisterEvent' && $route.name != 'UnPaidRegistration' && $route.name != 'Payment'" 
               md="1" sm="1" cols="1" style="color:#fff;">
          <LanguageSwitcher />
        </v-col>
      </v-row>
      <v-row v-if="dMenu" :class="`my-0 dMenu ${dMenuTransition ? 'act' : 'noact'}`">
        <v-col class="py-0">
          <v-list>
            <v-list-item @click="submit">
              <v-list-item-icon>
                <v-icon small>fa far fa-user</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t('top-menu.registration.menu_profile') }}</v-list-item-title>
            </v-list-item>
            <v-list-group
              no-action
            >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon>fa far fa-address-card</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('top-menu.registration.menu_registration') }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                link
                v-for="(item, i) in options[0].items"
                :key="i"
                @click="changePage(item.href)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{$t(item.lang)}}</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import TopMenu from "./TopMenu";
import LanguageSwitcher from "./LanguageSwitcher";
import { VRow, VCol } from 'vuetify/lib';
import { mapGetters } from 'vuex';
import defaultLogo from '@/assets/images/mainLogo.png';

export default {
  components: {
    VRow, VCol,
    TopMenu,
    LanguageSwitcher
  },
  data() {
    return {
      headerBGColor: "#FFF",
      dMenu: false,
      dMenuTransition: false,
      options: []
      }
  },
  methods: {
    onLogoError(e) {
      e.target.src = defaultLogo;
    },
    async changeDMenu() {
      const dMenu = !this.dMenu;
      if(dMenu) {
        this.dMenu = dMenu;
        await setTimeout(function() {
          this.dMenuTransition = true;
        }.bind(this), 10);
      } else {
        this.dMenuTransition = false;
        await setTimeout(function() {
          this.dMenu = dMenu;
        }.bind(this), 500);
      }
    },
    loadOptionsRegistration(options) {
      this.options = options ? options : [];
    },
    changePage(url) {
      window.location.href = url;
    },
    submit() {

      window.location.href = this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/admin/participantDashboard';
          
    }
  },
  computed: {
    ...mapGetters({
      storeLogoUrl: 'vueAppLogoView',
      sitesAppRoot: 'sitesAppRoot'
    }),
    logoUrl() {
      return this.storeLogoUrl || defaultLogo;
    }
  },
  created: function() {
    this.headerBGColor = this.$store.getters.env.get('VUE_APP_HEADER_COLOR');
  }
};
</script>

<style scoped>
#top_border {
  width: 100%;
  background: #45615f;
  background-color: rgb(69, 97, 95);
  margin: 0px;
  padding: 0px;
  border-bottom: 2px solid #aaa;
}
.v-toolbar {
  left: 300px !important;
}
@media (max-width: 1024px) {
  .v-toolbar {
    left: 0px !important;
  }
}
.header-resp {
  max-width: calc(100% - 320px);
}
.logo-resp {
  max-width: 203px;
}
.lang-resp {
  min-width: 110px;
}
.dMenu {
  align-items: center;
  visibility: hidden;
  opacity: 0;
  transition: visibility, opacity .5s, .5s linear;
  /*visibility: visible;
  opacity: 1;*/
}
.dMenu.act {
  visibility: visible;
  opacity: 1;
}
.dMenu.notact {
  opacity: 0;
}
@media (min-width: 769px) {
  .dMenu {
    display: none;
  }
}
@media (max-width: 850px) {
  .logout, #langl {
    float: right;
  }
  #langl {
    margin-right: 2rem;
  }
}
@media (max-width: 699px){
  .header-resp {
    display: contents;
  }
}
@media (max-width: 406px) {
  .logo-resp {
    display: none;
  }
}
</style>
